import React from 'react';
import { Trans } from 'react-i18next';
import useExportHistoryEnabled from '@src/hooks/useExportHistoryEnabled';
import useExportRetentionPeriod from '@src/hooks/useExportRetentionPeriod';

/**
 * How long an exported file will be downloadable, told before the export runs.
 *
 * Behind the export-history flag because the sentence sends the reader to the
 * "Lịch sử" tab, which only that flag renders.
 */
const ExportRetentionNote = () => {
  const historyEnabled = useExportHistoryEnabled();
  const retentionPeriod = useExportRetentionPeriod();

  if (!historyEnabled) return null;

  return (
    <div className="export-retention-note">
      <Trans
        i18nKey="exportRetentionNote"
        values={{ retentionPeriod }}
        components={[<b />, <b />]}
      />
    </div>
  );
};

export default ExportRetentionNote;
